"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhotoStringToPhotoArrayNode = void 0;
const BaseNode_1 = require("../../BaseNode");
const Schema = __importStar(require("./schema.json"));
const NODE_TYPE = 'PHOTO-TOARRAY';
class PhotoStringToPhotoArrayNode extends BaseNode_1.BaseNode {
    constructor() {
        super(...arguments);
        this._resolve = (params) => {
            const { input } = params;
            if (Array.isArray(input)) {
                return {
                    output: input,
                };
            }
            else {
                return {
                    output: (input && typeof input === 'string' && input.split(',').filter((item) => item !== '')) || [],
                };
            }
        };
        this._interfaceDefinition = Schema;
    }
}
exports.PhotoStringToPhotoArrayNode = PhotoStringToPhotoArrayNode;
PhotoStringToPhotoArrayNode._nodeDefinition = {
    NODE_TYPE,
    defaultTitle: 'Convert Legacy Photo String',
    isIdempotent: true,
    primaryCategory: 'Photo',
};
//# sourceMappingURL=PhotoStringToPhotoArray.js.map